<template>
    <v-dialog v-model="dialog" width="800" persistent>
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="d-inline">
                <slot></slot>
            </div>
        </template>
        <v-card>
            <v-card-title class="flex-nowrap align-start">
                Instance Usages
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>
            <v-card-subtitle class="text-capitalize">
                {{ fileTypeLabel(type) }}
            </v-card-subtitle>
            <v-card-text>
                <div class="d-flex align-center mb-3">
                    <v-text-field
                        prepend-inner-icon="mdi-magnify "
                        autofocus
                        hide-details
                        solo
                        flat
                        background-color="grey lighten-4"
                        dense
                        placeholder="Search for an instance..."
                        v-model="search"
                        clearable
                        @click:clear="search = ''"></v-text-field>
                </div>
                <v-data-table
                    :search="search"
                    :headers="headers"
                    :items="usagesArray"
                    :footer-props="{ 'items-per-page-options': itemsPerPageOptions }"
                    class="elevation-1 mt-4">
                    <template v-slot:top="{ pagination, options, updateOptions }">
                        <v-data-footer
                            :pagination="pagination"
                            :options="options"
                            @update:options="updateOptions"
                            :itemsPerPageOptions="itemsPerPageOptions"
                            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                            class="no-border" />
                    </template>
                    <template v-slot:no-data>
                        <span>No instance usages found.</span>
                    </template>
                    <template v-slot:[`item.usage`]="{ item }">
                        <div v-if="item.usage[type]">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-progress-linear
                                        v-on="on"
                                        :value="item.usage[type].usage_pct"
                                        :color="usageColor(item.usage[type].usage_pct)"
                                        rounded
                                        class="my-2"
                                        height="8"></v-progress-linear>
                                </template>
                            </v-tooltip>
                            <div class="d-flex">
                                <div>{{ item.usage[type].usage_pct }}% used</div>
                                <v-spacer></v-spacer>
                                <strong>{{ bytesToGB(item.usage[type].usage) }} GB</strong>
                                /
                                <span>{{ bytesToGB(item.usage[type].quota) }} GB</span>
                            </div>
                        </div>
                        <div v-else>No usage data to show</div>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions></v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import fileQuotas from '@/mixins/fileQuotas'

export default {
    name: 'FileQuotaInstanceUsagesDialog',
    components: {},
    mixins: [fileQuotas],
    props: {
        usages: { type: Object },
        type: { type: String }
    },
    data() {
        return {
            dialog: false,
            search: '',
            headers: [
                { text: 'Instance Name', value: 'instanceName', align: 'start' },
                { text: 'Usage', value: 'usage', align: 'start', sort: (a, b) => (a?.usage_pct || 0) - (b?.usage_pct || 0) }
            ],
            itemsPerPageOptions: [25, 50, 100, -1]
        }
    },
    computed: {
        usagesArray() {
            if (!this.usages) return []
            return Object.entries(this.usages).map(([instanceName, data]) => ({
                instanceName,
                ...data
            }))
        }
    },
    methods: {},
    watch: {}
}
</script>
